import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {quadIn} from "@amcharts/amcharts4/.internal/core/utils/Ease";
import {filterAutocomplete_template} from "./filterAutocomplete_template";

declare var ko: any;

export class jobProfilesEdit_template extends vnTemplate {

    public geosFilter: filterAutocomplete_template;

    protected getTemplateHtml(): string {

        return `
        
            <div class="form-header">
                <input id="user-id" data-bind="value: id" type="hidden">
                <!-- ko ifnot: $data.id() -->
                <h3 class="form-title icon i-profiles">Create Job Profile</h3>
                <!-- /ko -->

                <!-- ko if: $data.id() -->
                <h3 class="form-title icon i-profiles">Edit Job Profile</h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>
            
            <div class="ww-form-body" data-bind="css: { 'is-showing': isShowUserInfosTab }">
                <div class="w-form-body header">
                <div class="header-bg" style="background-image: url('https://static0.srcdn.com/wordpress/wp-content/uploads/jobProfiles/2023/03/profile-15-1.jpg')"></div>
                    <div class="form-body">
                        <strong class="form-sub-title">Public Information</strong>
                        <div class="form-group">
                            <label for="name" class="form-label">Position Title</label>
                            <input id="name" data-bind="value: name" type="text" class="input-text">
                        </div>
                        <div class="form-group row">
                            <label for="brand" class="form-label">Brand</label>
                            <select id="brand-select" name="brand" data-bind="
                                options: brands,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idBrand,
                                "> 
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="location" class="form-label">Location</label>
                            <input id="location" data-bind="value: location" type="text" class="input-text">
                        </div>
                        <div class="form-group">
                            <label for="availability" class="form-label">Availability</label>
                            <input id="availability" data-bind="value: availability" type="text" class="input-text">
                        </div>
                        <div class="form-group">
                            <label for="experience" class="form-label">Experience</label>
                            <input id="experience" data-bind="value: experience" type="text" class="input-text">
                        </div>
                        <div class="form-group">
                            <label for="longDescription" class="form-label">Website Description</label>
                            <textarea  id="longDescription" name="longDescription" data-bind="value: longDescription"></textarea>
                        </div>
                        <div class="form-group">
                            <label for="additionalText" class="form-label">Emaki Description</label>
                            <textarea  id="additionalText" data-bind="value: additionalText"></textarea>
                         </div>
                    </div>
                    
                    <div class="form-body">
                        <strong class="form-sub-title">Configuration</strong>
                        <div class="form-group row">
                            <label for="role" class="form-label">Role</label>
                            <select id="role-select" name="role" data-bind="
                                options: roles,
                                optionsValue: 'id',
                                optionsText: 'name',
                                optionsCaption: 'Choose a role',
                                value: idRole,
                                "> 
                            </select>
                        </div>
                        <div class="form-group row">
                            <label for="networkCategory" class="form-label">Network Category</label>
                            <select id="networkCategory-select" name="networkCategory" data-bind="
                                options: networkCategories,
                                optionsValue: 'id',
                                optionsText: 'name',
                                optionsCaption: 'Choose a network category',
                                value: idNetworkCategory,
                                "> 
                            </select>
                        </div>
                        <div class="form-group">
                            ` + this.geosFilter.getHtmlBuild() + ` 
                        </div>
                        <div class="form-group" data-bind="foreach: geos" style="margin-top: -3rem">
                            <div class="btn-selection">
                                <span data-bind="text: name"></span>
                                <button data-bind="event: {click: $parent.onClickRemoveGeo}" class="icon i-x-after" type="button"></button>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>
                        
                        <div class="form-group row">
                            <label for="resume" class="form-label">Resume</label>
                            <select id="resume-select" name="resume" 
                                data-bind="options: configOptions,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idResume"> 
                            </select>
                        </div>
                        
    
                        <div class="form-group row">
                            <label for="coverLetter" class="form-label">Cover Letter</label>
                            <select id="coverLetter-select" name="coverLetter" 
                                data-bind="options: configOptions,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idCoverLetter"> 
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>
                        
                        <div class="form-group row">
                            <label for="referentialWork" class="form-label">Links to Referential Work</label>
                            <select id="referentialWork-select" name="referentialWork" 
                                data-bind="options: configOptions,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idReferentialWork"> 
                            </select>
                        </div>
                        <div class="form-group" data-bind="visible: idReferentialWork() > 1">
                            <label for="referentialWorkInstructions" class="form-label">Instructions</label>
                            <textarea  id="referentialWorkInstructions" name="referentialWorkInstructions" data-bind="value: referentialWorkInstructions"></textarea>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>
                        
                        <div class="form-group row">
                            <label for="writtenSample" class="form-label">Written Sample</label>
                            <select id="writtenSample-select" name="writtenSample" 
                                data-bind="options: configOptions,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idWrittenSample"> 
                            </select>
                        </div>
                        <div class="form-group" data-bind="visible: idWrittenSample() > 1">
                            <label for="writtenSampleInstructions" class="form-label">Instructions</label>
                            <textarea  id="writtenSampleInstructions" name="writtenSampleInstructions" data-bind="value: writtenSampleInstructions"></textarea>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>
                        
                        <div class="form-group row">
                            <label for="imageSample" class="form-label">Image Sample</label>
                            <select id="imageSample-select" name="imageSample" 
                                data-bind="options: configOptions,
                                optionsValue: 'id',
                                optionsText: 'name',
                                value: idImageSample"> 
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <hr class="form-hr">
                        </div>
                        
                        <div class="form-group" data-bind="visible: idImageSample() > 1 ">
                            <label for="imageSampleInstructions" class="form-label">Instructions</label>
                            <textarea  id="imageSampleInstructions" name="imageSampleInstructions" data-bind="value: imageSampleInstructions"></textarea>
                        </div>
                        
                        <div class="form-group row">
                            <strong class="form-label">Custom Questions</strong>
                            <button type="button" data-bind="event: { click: onClickShowCreateDialog }" class="btn border only-icon icon">+</button>
                        </div>
                        
                        <div data-bind="foreach: questions">
                            <div class="form-group" style="border-bottom: 1px solid #e4e4e4;">
                                <span class="form-label" data-bind="text: $parent.configOptions().find(function(e) {if(e.id == id){return e}}).name"></span><br>
                                <div style="display: flex; flex-direction: row; align-items: center;padding: .25rem 0;">
                                    <span style="flex: 1;align-items: center" class="form-text" data-bind="html: question"></span>
                                    <button type="button" data-bind="event: { click: function() { $parent.onClickEditQuestion($data, $index()) } }, clickBubble: false" class="btn border only-icon icon i-edit"></button>
                                    <button type="button" style="margin-left: .5rem" data-bind="event: { click: function(){ $parent.onClickShowDeleteDialog($data, $index()) }}, clickBubble: false" class="btn border only-icon highlight icon i-delete"></button>
                                </div>
                            </div>
                        </div>
                   
                       
                    </div>
                </div>
            </div>
            <div class="form-footer">                
                <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save Profile</button> 
            </div>
            
            <div id="create-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form" style="width: 40rem">
                        <div class="form-header">
                            <h3 class="form-title">Add Question</h3>
                            <button type="button"  data-bind="event: { click: onClickHideCreateDialog }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group row">
                                <label for="question" class="form-label">Question</label>
                                <select id="question-select" name="question" data-bind="options: questionConfigOptions,optionsValue: 'id',optionsText: 'name',value: idQuestion"> </select>
                            </div>
                            <div class="form-group">
                                <label for="question" class="form-label"></label>
                                <textarea id="question" name="question"></textarea>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideCreateDialog }" class="btn">Cancel</button>
                            <button type="button" data-bind="enable: !questionEditorTextIsEmpty() && idQuestion() != 1, event: { click: onClickSaveQuestion }" class="btn highlight">Apply</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            
            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting Question</h3>
                            <button type="button"  data-bind="event: { click: onClickHideDeleteDialog }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this question:
                                    <div data-bind=" if: deletingObject()">
                                        <label for="question" class="form-label">Question</label>
                                        <select id="question-select" name="question" data-bind="options: configOptions,optionsValue: 'id',optionsText: 'name',value: deletingObject().id" disabled> </select>
                                        <span data-bind="html: deletingObject().question"></span>
                                    </span>
                                </div>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideDeleteDialog }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDeleteQuestion }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            
            `;
    }

    protected initPartial(): void {

        this.geosFilter = new filterAutocomplete_template("filterAutocompleteGEO_template", this.getTemplateViewModel(), this.caller);
        this.geosFilter.setAddNewOptionEnabled(false);
        this.geosFilter.setHasDisplayNameComplement(false);
        this.geosFilter.setIsShowCurrentSelection(false);
        this.geosFilter.setNumberOfChars(1);
        this.geosFilter.setPlaceholderAndLabel("PERMITTED GEO");
    }

    protected getTemplateName(): string {

        return "jobProfileEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {

        let huit_neuf_this = this;
        let viewModel = {
            loggedUserId: ko.observable("")
            ,id: ko.observable(null)
            ,name: ko.observable("")
            ,brands: ko.observableArray([])
            ,idBrand: ko.observable()
            ,location: ko.observable("")
            ,availability: ko.observable("")
            ,experience: ko.observable("")
            ,longDescription: ko.observable("")
            ,additionalText: ko.observable("")
            ,roles: ko.observableArray([])
            ,geos: ko.observableArray([])
            ,idRole: ko.observable("")
            ,networkCategories: ko.observableArray([])
            ,idNetworkCategory: ko.observable()
            ,configOptions: ko.observableArray([])
            ,idResume: ko.observable("")
            ,idCoverLetter: ko.observable("")
            ,idReferentialWork: ko.observable("")
            ,referentialWorkInstructions: ko.observable("")
            ,idWrittenSample: ko.observable("")
            ,writtenSampleInstructions: ko.observable("")
            ,idImageSample: ko.observable("")
            ,imageSampleInstructions: ko.observable("")
            ,idQuestion: ko.observable(1)
            ,questions: ko.observableArray([])
            ,deletingObject: ko.observable(null)
            ,editingObjectIndex: ko.observable(null)
            ,questionConfigOptions: ko.observableArray([])
            ,position: ko.observable("")
            ,imageUrl: ko.observable("")
            ,isActive: ko.observable(0)
            ,lastDateEnabled: ko.observable("")
            ,lastDateDisabled: ko.observable("")
            ,isShowUserInfosTab: ko.observable(true)
            ,hasAdminRole: ko.observable(false)
            ,lockItem: ko.observable(true)
            ,questionEditorTextIsEmpty: ko.observable(true)
            ,onClickSave: function (data, event) {huit_neuf_this.save();}
            ,onClickCancel: function (data, event) {huit_neuf_this.cancel();}
            ,onClickShowCreateDialog: function (data, event) {huit_neuf_this.showCreateDialog();}
            ,onClickHideCreateDialog: function (data, event) {huit_neuf_this.hideCreateDialog();}
            ,onClickEditQuestion: function (data, index, event) {huit_neuf_this.editQuestion(data, index);}
            ,onClickSaveQuestion: function (data, event) {huit_neuf_this.saveQuestion();}
            ,onClickShowDeleteDialog: function (data, index ,event) {huit_neuf_this.showDeleteDialog(data, index);}
            ,onClickHideDeleteDialog: function (data, event) {huit_neuf_this.hideDeleteDialog();}
            ,onClickDeleteQuestion: function (data, event) {huit_neuf_this.deleteQuestion();}
            ,onClickRemoveGeo: function (data) {huit_neuf_this.onClickRemoveGeo(data)}

        };
        return viewModel;
    }

    public setLoggedUserId(id){

        this.getTemplateViewModel().loggedUserId(id);
    }

    public setId(id){

        this.getTemplateViewModel().id(id);
    }

    public setName(name){

        this.getTemplateViewModel().name(name);
    }

    public setAvailability(availability){

        this.getTemplateViewModel().availability(availability);
    }

    public setLocation(location){

        this.getTemplateViewModel().location(location);
    }

    public setExperience(experience){

        this.getTemplateViewModel().experience(experience);
    }

    public setLongDescription(longDescription){

        this.getTemplateViewModel().longDescription(longDescription);
    }

    public setAdditionalText(additionalText){

        this.getTemplateViewModel().additionalText(additionalText);
    }

    public setIdResume(idResume){

        this.getTemplateViewModel().idResume(idResume);
    }

    public setIdCoverLetter(idCoverLetter){

        this.getTemplateViewModel().idCoverLetter(idCoverLetter);
    }

    public setIdReferentialWork(idReferentialWork){

        this.getTemplateViewModel().idReferentialWork(idReferentialWork);
    }

    public setIdWrittenSample(idWrittenSample){

        this.getTemplateViewModel().idWrittenSample(idWrittenSample);
    }

    public setIdImageSample(idImageSample){

        this.getTemplateViewModel().idImageSample(idImageSample);
    }

    public setPosition(position){

        this.getTemplateViewModel().position(position);
    }

    public setImageUrl(imageUrl){

        this.getTemplateViewModel().imageUrl(imageUrl);
    }

    public setIsActive(isActive){

        this.getTemplateViewModel().isActive(isActive);
    }

    public setLastDateEnabled(lastDateEnabled){

        this.getTemplateViewModel().lastDateEnabled(lastDateEnabled);
    }

    public setLastDateDisabled(lastDateDisabled){

        this.getTemplateViewModel().lastDateDisabled(lastDateDisabled);
    }

    public setNetworkCategories(networkCategories){

        this.getTemplateViewModel().networkCategories(networkCategories);
    }

    public setConfigOptions(configOptions){

        this.getTemplateViewModel().configOptions(configOptions);
    }

    public setQuestionConfigOptions(questionConfigOptions){

        this.getTemplateViewModel().questionConfigOptions(questionConfigOptions);
    }

    public setIdNetworkCategory(idNetworkCategory){

        this.getTemplateViewModel().idNetworkCategory(idNetworkCategory);
    }

    public setRoles(roles){

        this.getTemplateViewModel().roles(roles);
    }

    public setGeos(geos){

        this.getTemplateViewModel().geos(geos);
    }

    public setIdRole(idRole){

        this.getTemplateViewModel().idRole(idRole);
    }

    public setBrands(brands){

        this.getTemplateViewModel().brands(brands);
    }

    public setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setQuestions(questions){

        this.getTemplateViewModel().questions(questions);
    }

    public save() {

        this.caller.saveJob();
    }

    public cancel() {

        this.caller.cancel();
    }

    public showCreateDialog(){

        this.toggleCreateDialogVisibility();
    }

    public hideCreateDialog(){

        this.toggleCreateDialogVisibility();
    }

    public editQuestion(data, index){
        this.showCreateDialog();
        this.getTemplateViewModel().editingObjectIndex(index);
        this.getTemplateViewModel().idQuestion(data.id);
        this.caller.setQuestionEditorData(data.question)
    }

    public saveQuestion(){
        let id = this.getTemplateViewModel().idQuestion();
        let questionText = this.caller.getQuestionEditorData();
        let questions = this.getTemplateViewModel().questions();

        const editObjectIndex = this.getTemplateViewModel().editingObjectIndex()
        if(editObjectIndex === null){
            this.getTemplateViewModel().questions.push({ id: id, question: questionText});
            this.getTemplateViewModel().questions([]);
            this.getTemplateViewModel().questions(questions);
        }else{
            this.getTemplateViewModel().questions.splice(editObjectIndex, 1, { id: id, question: questionText });
        }
        this.resetCreateDialog();
        this.hideCreateDialog();
    }

    public resetCreateDialog(){

        this.caller.setQuestionEditorData('');
        this.getTemplateViewModel().idQuestion(1);
        this.getTemplateViewModel().editingObjectIndex(null)
    }

    public toggleCreateDialogVisibility() {

        document.getElementById('create-dialog').classList.toggle('is-visible');
        this.resetCreateDialog();
    }

    public showDeleteDialog(data, index){
        const deletingObject = {...data, index}
        this.getTemplateViewModel().deletingObject(deletingObject);
        this.toggleDeleteDialogVisibility();
    }

    public hideDeleteDialog(){
        this.getTemplateViewModel().deletingObject(null)
        this.toggleDeleteDialogVisibility();
    }

    public deleteQuestion(){

        let question = this.getTemplateViewModel().deletingObject();
        const { index } = question
        const questions = this.getTemplateViewModel().questions()
        questions.splice(index, 1)
        this.getTemplateViewModel().questions([]);
        this.getTemplateViewModel().questions(questions);
        this.getTemplateViewModel().deletingObject(null)
        this.toggleDeleteDialogVisibility();
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    protected onClickRemoveGeo(data){

        let geos = this.getTemplateViewModel().geos();
        let newGeos = geos.filter((geo) => geo.id != data.id);
        this.getTemplateViewModel().geos(newGeos);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/jobProfilesEdit_template.ts